import { render, staticRenderFns } from "./semminary.vue?vue&type=template&id=10b0892b&scoped=true&"
import script from "./semminary.vue?vue&type=script&lang=js&"
export * from "./semminary.vue?vue&type=script&lang=js&"
import style0 from "./semminary.vue?vue&type=style&index=0&id=10b0892b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0892b",
  null
  
)

export default component.exports